// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import useStoreTimToa from "../../../store/useStoreTimToa";
import { Icons } from "../../spinner";

export function OpenCloseTSK() {
  const [options, setOptions] = useState({});
  const { openCloseTSKData, loadingChartPriorityByTime } = useStoreTimToa(
    (state) => state
  );

  const transformData = (data) => {
    if (!data?.Horas) return null;

    const hoursData = data.Horas;
    return [
      {
        name: "Tickets Abertos",
        type: "line",
        data: Object.values(hoursData.Abertas_por_hora),
        itemStyle: {
          color: "#22c55e", // verde
        },
      },
      {
        name: "Tickets Fechados",
        type: "line",
        data: Object.values(hoursData.Fechadas_por_hora),
        itemStyle: {
          color: "#ef4444", // vermelho
        },
      },
    ];
  };

  useEffect(() => {
    if (openCloseTSKData) {
      const series = transformData(openCloseTSKData);

      const options = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["Tickets Abertos", "Tickets Fechados"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: Array.from({ length: 24 }, (_, i) => `${i}H`),
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
          },
        },
        series,
      };

      setOptions(options);
    }
  }, [openCloseTSKData]);

  return (
    <>
      {openCloseTSKData ? (
        <div className="bg-gray-500 shadow-md rounded-sm col-span-2">
          <ReactECharts option={options} style={{ height: "450px", width: "100%" }} />
        </div>
      ) : loadingChartPriorityByTime ? (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <Icons.spinner className="h-12 w-12 animate-spin text-orange-300" />
        </div>
      ) : (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <p className="bg-slate-100 p-2 text-gray-500 rounded-md font-extrabold">
            SEM DADOS
          </p>
        </div>
      )}
    </>
  );
}
